import React from "react";
import { Redirect, withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import { CompleteCard, LoadingCard, CompleteDetailsCard } from "../components";
import { 
    updateHeaderInfo, 
    getAllQuestions,
    getQuestionResults,
    editDeck,
    addNote,
    getAccessList,
    shareDeck, emailResults, resetDeck, getDecks,
    getUserDetails,
    submitCME,
    setPrevPageDetails,
    removeShareDeck,
    resetQuiz
} from "../actions";
import { deviceData, scrollTop, DATA_LONG_LOAD } from "../common";
import "../styles/questionStyles.css";
import { AppBar, Divider, Tab, Tabs, Typography } from "@material-ui/core";

const a11yProps = (index) => {
    return {
        id: `profile-tab-${index}`,
        'aria-controls': `profile-tabpanel-${index}`,
    };
}

class CompletedTestScreen extends React.Component {
    state = {
        results: null,
        state: false,
        show: false,
        obj: {},
        tracking: null,
        showComplete: 0,
        value: 0,
        loadingtext: 'Loading Test Data...',
        interval: -1
    }

    randomtext = () => {
        const arr = DATA_LONG_LOAD;
    
        let cnt = 0;
    
        let interval = setInterval(() => {
            const randomIndex = cnt % arr.length;
            let t = arr[randomIndex];
            this.setState({ ...this.state, loadingtext : t});
            cnt++;
        }, 3500, cnt);
    
        return this.setState({ ...this.state, interval: interval });
    }
    
    componentDidMount = async () => {
        // removeClass('mainFooter', ['hidden']);
        // addClass('mainFooter', ['hidden']);
        const loadingtext = this.randomtext();

        scrollTop();

        await this.props.updateHeaderInfo({
            route:"/testResultScreen", 
            name: "Summary", 
            iconTwo: 'menu', 
            iconOne: 'home',
            color: this.state.backgroundColor
        });

        let obj = {
            mcid: this.props.auth_feedback.mcid, 
            key: this.props.auth_feedback.key,
            gamemode: this.props.location.gameMode ? this.props.location.gameMode : this.props.question.gameMode,
        };

        let _submit = 0;
        let subtracking = deviceData(this.props.location, 'claim cme');
        subtracking.action = 'claim cme';

        if (typeof this.props.location.deckID !== 'undefined') {
            obj.deckID = this.props.location.deckID;
        } else if (Number(this.props.question.gameMode) === 5) {
            obj.deckID = this.props.prevPage.deckID;
        } else if (typeof this.props.question !== 'undefined' && typeof this.props.location.testYear === 'undefined') {
            _submit = 1;

            obj.yearvar = this.props.question.QuestionYear ? this.props.question.QuestionYear : this.props.question.availableyears;

            let sobj = {
                mcid: this.props.auth_feedback.mcid, 
                key: this.props.auth_feedback.key,
                gamemode: this.props.location.gameMode ? this.props.location.gameMode : this.props.question.gameMode,
                qyear: obj.yearvar
            };

            await this.props.submitCME(sobj, subtracking);
        }

        if (typeof this.props.location.testYear !== 'undefined' && !_submit) {
            obj.yearvar = this.props.location.testYear;

            let sobj = {
                mcid: this.props.auth_feedback.mcid, 
                key: this.props.auth_feedback.key,
                gamemode: this.props.location.gameMode ? this.props.location.gameMode : this.props.question.gameMode,
                qyear: this.props.location.testYear,
            };
            
            await this.props.submitCME(sobj, subtracking);
        }

        if (typeof this.props.deckList === 'undefined') {
            await this.props.getDecks({
                mcid: obj.mcid, 
                key: obj.key
            });
        }

        obj.tracking = deviceData(this.props.location, 'navigate') ;
        obj.tracking.action = 'navigate';

        let programid = null;

        if (typeof this.props.user_details.program !== 'undefined') {
            programid = this.props.user_details.program.programid;
        }
        
        await this.props.getQuestionResults( obj );

        if (Array.isArray(this.props.accessList) && this.props.accessList.length === 0) {
                await this.props.getAccessList({
                mcid: this.props.auth_feedback.mcid,
                key: this.props.auth_feedback.key,
                programid: programid
            });
        }

        return this.setState({ ...this.state, obj: obj, tracking: deviceData(this.props.location, 'navigate') });
    }

    componentDidUpdate = async (prevProps, prevState) => {
        if (prevProps.get_question_results !== this.props.get_question_results) {
            let _bool = 0;

            if (this.props.get_question_results.totalscore >= 50) {
                _bool = 1;
            }

            return this.setState({...this.state, results: this.props.get_question_results, showComplete: _bool});
        }

        if (prevProps.user_details !== this.props.user_details) {
            return this.setState({ ...this.state, show: true, });
        }

        if (prevState.obj !== this.state.obj ) {
            return this.setState({ ...this.state, show: true })
        }

        if (prevState.results !== this.state.results) {
            return this.setState({ ...this.state, show: true })
        }
    }

    componentWillUnmount = async () => {
        // return removeClass('mainFooter', ['hidden']);
    }

    resetDeck = async (data) => {
        await this.props.resetDeck(data);

        return this.props.history.push('/home');

        // return <Redirect to={{ pathname: '/home' }} />
    }

    resetTest = async () => {
        await this.props.resetQuiz();

        return null;
    }

    emailResults = async (data, tracking) => {
        data.subject = '<p>' + data.subject + '</p>'
        data.subject = data.subject.replace(/\n/g, '</p><p>');
        data.subject = data.subject.replace(/\r/g, '</p><p>');
        data.subject = data.subject.replace(/<\/p><p><\/p><p>/g, '</p><p>');

        if (typeof tracking !== 'undefined') {
            await this.props.emailResults(data, deviceData(this.props.location, 'email result'));
        } else {
            await this.props.emailResults(data);
        }        
    }

    shareDeck = async (data) => {
        if (typeof tracking !== 'undefined') {
            await this.props.shareDeck(data, deviceData(this.props.location, 'share deck'));
        } else {
            await this.props.shareDeck(data);
        } 
    }

    setComplete = async (bool) => {
        await this.setState({
            ...this.state,
            showComplete: bool,
        })
    }

    addNote = async (data) => {
        this.setState({
            ...this.state,
            show: false,
        })
        await this.props.addNote(data);
        await this.props.getUserDetails(data.mcid, data.key, deviceData(this.props.location, 'add note'));

        scrollTop();
    }

    submitCME = async (data) => {
        await this.props.submitCME(data, deviceData(this.props.location, 'claim cme'));
    }

    setPrevPageDetails = async (data) => {
        await this.props.setPrevPageDetails(data);
    }

    setContainer = (bool) => {
        return { padding: "0px 16px 32px", margin: "calc(env(safe-area-inset-top) + 56px) 0 64px", width: "calc(100%)", overflowY: "auto" };
    }

    removeShare = (data) => {
        return this.props.removeShareDeck(data);
    }

    handleChange = (event, newValue) => {
        return this.setState({ ...this.state, value: newValue });
    }; 

    setBool = (val) => {
        let r = false;
        if (val) { r = true; }

        return r;
    }

    render() {
        try {
            if (this.state.show && typeof this.props.deckList !== 'undefined') { 
                try {
                    clearInterval(this.state.interval)
                } catch (e) {
                }

                return (
                    <>
                        <div className="" id="CompletedTestDiv" style={{zIndex: '5'}}>
                            <div className="anchor" style={{height: '100%', background: 'white'}}>
                                <AppBar
                                    position="fixed"
                                    scrollButtons="auto"
                                    variant="scrollable"
                                    style={{
                                        marginTop: 'calc(0px + env(safe-area-inset-top))',
                                        background: 'var(--aua-app-theme-color)',
                                        color: 'white',
                                        left: '0px',
                                        top: 'unset',
                                        width: '100vw',
                                        bottom: '0',
                                        padding: '0 0 calc(env(safe-area-inset-bottom) / 2)',
                                        height: `calc(56px + env(safe-area-inset-bottom))`
                                    }}
                                >
                                    <Tabs value={this.state.value} onChange={this.handleChange} aria-label="Test Results Page tabs" className="flex-row-centered">
                                        <Tab className="core-footer-btn" label="Summary" {...a11yProps(0)}/>
                                        <Tab className="core-footer-btn" label="Details" {...a11yProps(1)}/>
                                        <Tab className="core-footer-btn inactive disabled" label="" {...a11yProps(2)} disabled={true} />
                                    </Tabs>
                                </AppBar>

                                <div
                                    role="tabpanel"
                                    hidden={this.state.value !== 0}
                                    id={`completed-tab-panel-${0}`}
                                    aria-labelledby={`completed-tab-panel-${0}`}                            
                                >
                                    <CompleteCard
                                        id="completeScreen-div"
                                        user_details={this.props.user_details}
                                        mcid={this.props.user_details.mcid}
                                        key={this.props.user_details.key}
                                        myKey={this.props.user_details.key}
                                        questionCount={this.props.get_question_count}
                                        newDeckInfo={this.props.newDeckInfo}
                                        updateHeaderInfo={this.props.updateHeaderInfo}
                                        deckList={this.props.deckList}
                                        question={this.props.question}
                                        getAllQuestion={this.props.getAllQuestions}
                                        getQuestionResults={this.props.getQuestionResults}
                                        gameMode={this.state.obj.gamemode ? this.state.obj.gamemode : this.props.question.gameMode}
                                        deckID={this.state.obj.deckID ? this.state.obj.deckID : null}
                                        results={this.state.results}
                                        deck={this.state.obj.deckID ? this.props.deckList.find(item => item.deckID === this.state.obj.deckID) : null}
                                        show={this.state.show}
                                        editDeck={this.props.editDeck}
                                        addNote={this.addNote}
                                        accessList={this.props.accessList}
                                        shareDeck={this.shareDeck}
                                        emailResults={this.emailResults}
                                        resetDeck={this.resetDeck}
                                        submitCME={this.submitCME} 
                                        container={{background: 'white'}}
                                        testYear={this.state.obj.yearvar}
                                        showComplete={this.state.showComplete}
                                        totalscore={Math.trunc(this.state.results.totalscore)}
                                        setComplete={this.setComplete}
                                        setPrevPageDetails={this.setPrevPageDetails}
                                        removeShare={this.removeShare}
                                    />
                                </div>

                                <div
                                    role="tabpanel"
                                    hidden={this.state.value !== 1}
                                    id={`completed-tab-panel-${1}`}
                                    aria-labelledby={`completed-tab-panel-${1}`}                            
                                >
                                    <CompleteDetailsCard
                                        id="completeDetailsScreen-div"
                                        user_details={this.props.user_details}
                                        mcid={this.props.user_details.mcid}
                                        key={this.props.user_details.key}
                                        myKey={this.props.user_details.key}
                                        questionCount={this.props.get_question_count}
                                        newDeckInfo={this.props.newDeckInfo}
                                        updateHeaderInfo={this.props.updateHeaderInfo}
                                        deckList={this.props.deckList}
                                        question={this.props.question}
                                        getAllQuestion={this.props.getAllQuestions}
                                        getQuestionResults={this.props.getQuestionResults}
                                        gameMode={this.state.obj.gamemode ? this.state.obj.gamemode : this.props.question.gameMode}
                                        deckID={this.state.obj.deckID ? this.state.obj.deckID : null}
                                        results={this.state.results}
                                        deck={this.state.obj.deckID ? this.props.deckList.find(item => item.deckID === this.state.obj.deckID) : null}
                                        show={this.state.show}
                                        editDeck={this.props.editDeck}
                                        addNote={this.addNote} 
                                        accessList={this.props.accessList}
                                        shareDeck={this.shareDeck}
                                        emailResults={this.emailResults}
                                        resetDeck={this.resetDeck}
                                        submitCME={this.submitCME} 
                                        container={{background: 'white'}}
                                        testYear={this.state.obj.yearvar}
                                        showComplete={this.state.showComplete}
                                        totalscore={Math.trunc(this.state.results.totalscore)}
                                        setComplete={this.setComplete}
                                        setPrevPageDetails={this.setPrevPageDetails}
                                        removeShare={this.removeShare}
                                        responses={this.state.results.questions}
                                        resetQuiz={this.resetTest}
                                    />
                                </div>

                                <div
                                    role="tabpanel"
                                    hidden={this.state.value !== 2}
                                    id={`completed-tab-panel-${2}`}
                                    aria-labelledby={`completed-tab-panel-${2}`}                            
                                >
                                    <div>
                                        <Typography className="homeDividerText padding-top-8">
                                            
                                        </Typography>
                                        <Divider className="TestsDivider" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                );
            } else {
                return (
                    <LoadingCard textarray={this.state.loadingtext}/>
                )
            }
        } catch (e) {
            console.log(this.state);
            console.log(e);
            return <Redirect to={`/home`} error={e}/>
        }
    }
}

const mapStateToProps = state => {
    const { user_details, auth_feedback, accessList } = state.auth;
    const { newDeckInfo, deckList } = state.decks;
    const { question, sessionAnsweredQuestion, get_question_count, get_question_results } = state.question;
    const { headerText, iconOne, iconTwo, backgroundcolor } = state.style;
    const { prevPage } = state.device
    return { 
        user_details, 
        auth_feedback,
        accessList,
        newDeckInfo, 
        deckList, 
        question, 
        sessionAnsweredQuestion,
        get_question_count,
        get_question_results,
        headerText, iconOne, iconTwo, backgroundcolor, prevPage
    };
};

// export default connect(mapStateToProps, {})(withRouter(CompleteTestScreen))

export default connect(mapStateToProps, {
    updateHeaderInfo,
    getAllQuestions,
    getQuestionResults,
    editDeck,
    addNote,
    getUserDetails,
    getAccessList, shareDeck, emailResults, resetDeck, getDecks, submitCME, setPrevPageDetails, removeShareDeck, resetQuiz
})(withRouter(CompletedTestScreen));
